import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'
import type { GatewayListFilterFormSlice, GatewayListFilterTraitsSource } from '../types/gatewayListFilters.types'

import { applyGatewayListFilters } from './applyGatewayListFilters'

export type GatewayListOptionDimension = 'status' | 'runtime' | 'feed' | 'projectKey'

/** Gateways that match every active filter except `omit` — used to build dependent dropdown options. */
export function filterSourcesForGatewayListOptions(
  sources: GatewayListFilterTraitsSource[],
  filters: GatewayListFilterFormSlice,
  omit: GatewayListOptionDimension
): GatewayListFilterTraitsSource[] {
  const scopedFilters: GatewayListFilterFormSlice = {
    status: omit === 'status' ? GATEWAY_LIST_FILTER_ALL : filters.status,
    runtime: omit === 'runtime' ? GATEWAY_LIST_FILTER_ALL : filters.runtime,
    feed: omit === 'feed' ? GATEWAY_LIST_FILTER_ALL : filters.feed,
    projectKey: omit === 'projectKey' ? GATEWAY_LIST_FILTER_ALL : filters.projectKey,
    search: '',
  }

  return applyGatewayListFilters(sources, scopedFilters)
}
